/** Substrings matched (case-insensitive) on food-type labels for logged-out Ramadan hiding. */
const LOGGED_OUT_RAMADAN_FOOD_TYPE_TOKENS = ['ramadan', 'ramazan', 'futoor', 'suhoor'] as const;

export function menuBuilderFoodTypeMatchesLoggedOutRamadanFilter(builder: {
  type_name?: string;
  a_type_name?: string;
}): boolean {
  const haystack = `${builder.type_name ?? ''} ${builder.a_type_name ?? ''}`.toLowerCase();
  return LOGGED_OUT_RAMADAN_FOOD_TYPE_TOKENS.some(token => haystack.includes(token));
}

/**
 * When `logged_out_ramadan_menu` is false, strip Ramadan/futoor/suhoor food types from
 * logged-out Main → menu browse only. Logged-in menus and subscription plans are unchanged.
 */
export function filterMenuBuildersForLoggedOutRamadanMenu<
  T extends { type_name?: string; a_type_name?: string },
>(
  builders: T[] | null | undefined,
  opts: { is_guest_from_main: boolean; logged_out_ramadan_menu: boolean },
): T[] | null | undefined {
  if (!builders?.length) {
    return builders;
  }
  if (!opts.is_guest_from_main || opts.logged_out_ramadan_menu) {
    return builders;
  }
  return builders.filter(b => !menuBuilderFoodTypeMatchesLoggedOutRamadanFilter(b));
}
